import React, { useEffect } from 'react';
import { useChat } from '../../../contexts/ChatContext';
import { ChatHeader } from './ChatHeader';
import { ChatMessagesList } from './ChatMessagesList';
import { ChatInputArea } from './ChatInputArea';
import Box from "@mui/material/Box";
import {RIGHT_DRAWER_WIDTH} from "../../../constants/styles";
import {useRightDrawer} from "../../../contexts/application/RightDrawerContext";
import {enqueueSnackbar} from "notistack";

import { useGetMenuMaster, handlerDrawerOpen as handlerDashboardDrawerOpen } from 'api/menu';
import {useFullscreenChat, widthChat} from "@/contexts/FullscreenContext";
import {sendConversationalMessage} from "@/queries/agentQueries";

const Chat: React.FC = () => {
    const { messages, sendChatMessage, isThinking } = useChat();

    // Estraiamo il contesto della Chat (si purtroppo any)
    const drawerContext = useRightDrawer() as any;
    const closeDrawer = drawerContext.closeDrawer;

    const isChatOpen = drawerContext.isOpen || drawerContext.open || drawerContext.isDrawerOpen || drawerContext.isRightDrawerOpen;

    // Leggiamo lo stato della Dashboard
    const { menuMaster } = useGetMenuMaster();
    const isDashboardDrawerOpened = menuMaster?.isDashboardDrawerOpened || false;

    // Apri la chat, chiudi dashboard
    useEffect(() => {
        if (isChatOpen === true && isDashboardDrawerOpened === true) {
            handlerDashboardDrawerOpen(false);
        }
    }, [isChatOpen]);

    // Apri dashboard, chiudi chat
    useEffect(() => {
        if (isDashboardDrawerOpened === true && isChatOpen === true) {
            closeDrawer();
        }
    }, [isDashboardDrawerOpened]);

    const {isFullscreenChat, conversationalMessages, sendConversationalChatMessage, isThinkingConversational} = useFullscreenChat();

    const handleUserSendMessage = async (text: string) => {
        if (!text.trim()) return;
        try{
            if(isFullscreenChat)
                await sendConversationalChatMessage(text)
            else
                await sendChatMessage(text);
        }catch(e){
            console.error(e);
            enqueueSnackbar("Error sending message to AI agent");
        }
    };

    return (
        <Box>
            <Box height={'65px'} display={'flex'} alignItems={'center'} p={2} sx={{ width: '100%', borderBottom: '1px solid', borderColor: 'divider' }}>
                <ChatHeader onClose={closeDrawer}/>
            </Box>
            <Box
                sx={{
                    height: 'calc(100% - 130px)',
                    width: widthChat(isChatOpen, isFullscreenChat),

                    // 2. Posizionamento e gestione del layout interno
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 2,
                    position: 'fixed',
                    bottom: 0,
                    top: '130px',
                    zIndex: 1300,

                    // 3. Taglia drasticamente qualsiasi overflow o animazione che esce dai bordi
                    overflow: 'hidden',
                    boxSizing: 'border-box'
                }}
            >
                {/*<ChatHeader conversationId={conversationId} onClose={closeConversation} />*/}

                {/* Il trucco per non avere spazi bianchi nascosti risiede nel CSS di questo Box intermedio */}
                <ChatMessagesList messages={isFullscreenChat ? conversationalMessages : messages} isThinking={isFullscreenChat ? isThinkingConversational : isThinking} />

                <ChatInputArea onSendMessage={handleUserSendMessage} />
            </Box>
        </Box>
    );
};

export default Chat;